
import { BrowserInfo } from "@/utils/browser";
import { ElectronFunctions } from "@/utils/electron/electron";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			url: BrowserInfo.getElectronUrl()
		};
	},
	computed: {
		show():boolean{
			return !BrowserInfo.isElectron();
		}
	},
	methods: {
		async save(){
			try{
				if (this.url) {
					await ElectronFunctions.testServer(this.url);
				}
				BrowserInfo.setElectronUrl(this.url);
				this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
			}catch(err){
				let message = this.$ct("failed-to-test-if-desktop-server-is-running");
				this.$wf.dialog(message, this.$ct("common.ok"), this.$ct("common.error"), "warning");
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default",
	}
});
